(function () {
  function setBack(label, href) {
    var a = document.getElementById("hp-back-dynamic");
    var s = document.getElementById("hp-back-dynamic-label");
    if (!a || !s) return;
    a.href = href;
    s.textContent = label;
  }

  var path = window.location.pathname.replace(/\/$/, "");

  /*
    Priorité HYMAPRO :
    - Les sous-collections SEO des kits renvoient toujours vers la collection principale Kits d'hygiène
    - La collection principale Kits d'hygiène renvoie vers Catalogue
    Cette règle passe AVANT sessionStorage pour éviter qu'un ancien "Catalogue" soit réutilisé.
  */

  var collectionHandle = null;

  if (path.indexOf("/collections/") === 0) {
    collectionHandle = path.replace("/collections/", "").split("/")[0];
  }

  var kitsSubCollections = [
    "kits-accueil-urgence",
    "kits-hebergement-social-collectif",
    "kits-maraude-distribution",
    "kits-hygiene-femme-protections",
    "kits-hygiene-homme-rasage",
    "kits-toilette-sans-rincage",
    "kits-hygiene-enfant-famille",
    "kits-installation-logement",
    "kits-hygiene-etudiants-jeunes"
  ];

  if (collectionHandle === "kits-hygiene-structures-sociales") {
    setBack("Catalogue", "/pages/catalogue");
    return;
  }

  if (kitsSubCollections.indexOf(collectionHandle) !== -1) {
    setBack("Kits d’hygiène", "/collections/kits-hygiene-structures-sociales");
    return;
  }

  var params = new URLSearchParams(window.location.search);
  var from = params.get("from");

  // Mappings existants
  var map = {
    "catalogue": { label: "Catalogue", href: "/pages/catalogue" },
    "box-kits": { label: "Box & Kits", href: "/pages/box-kits" },
    "hygiene-corporelle": { label: "Hygiène corporelle", href: "/pages/hygiene-corporelle" }
  };

  // Si un paramètre direct est présent, on l'utilise + on le stocke pour la session
  if (from && map[from]) {
    try { sessionStorage.setItem("hp_last_from", from); } catch (e) {}
    setBack(map[from].label, map[from].href);
    return;
  }

  // Sinon, on essaie sessionStorage
  try {
    var saved = sessionStorage.getItem("hp_last_from");
    if (saved && map[saved]) {
      setBack(map[saved].label, map[saved].href);
      return;
    }
  } catch (e) {}

  // Fallback
  setBack("Catalogue", "/pages/catalogue");
})();